import React from 'react';
import { Col, DatePicker, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const DateSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Date')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data dal')} name='date_from'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data al')} name='date_to'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Data scadenza adesione')}
          name='membership_expiration_date'
        >
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DateSection);
